// 时间格式化工具：兼容后端 LocalDateTime 序列化字符串（ISO）与毫秒/秒时间戳

function pad (n) {
    return n < 10 ? '0' + n : '' + n
}

function formatDate (date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

// 统一格式化为 YYYY-MM-DD HH:mm:ss；无法解析时原样返回
export function formatDateTime (value) {
    if (value === null || value === undefined || value === '') return '-'

    // 数字时间戳：10 位按秒、13 位按毫秒处理
    if (typeof value === 'number') {
        const ms = String(value).length <= 10 ? value * 1000 : value
        return formatDate(new Date(ms))
    }

    if (typeof value === 'string') {
        // 纯数字字符串按时间戳处理
        if (/^\d+$/.test(value)) {
            return formatDateTime(Number(value))
        }
        // ISO 格式（LocalDateTime 默认序列化，如 2026-10-23T16:00:00）
        const parsed = new Date(value.replace('T', ' '))
        if (!isNaN(parsed.getTime())) {
            return formatDate(parsed)
        }
    }

    return String(value)
}

// 复制文本到剪贴板：优先 Clipboard API，降级 execCommand
export function copyText (text) {
    return new Promise((resolve, reject) => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(text).then(resolve, () => fallbackCopy(text, resolve, reject))
        } else {
            fallbackCopy(text, resolve, reject)
        }
    })
}

function fallbackCopy (text, resolve, reject) {
    try {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        const ok = document.execCommand('copy')
        document.body.removeChild(textarea)
        ok ? resolve() : reject(new Error('复制失败'))
    } catch (error) {
        reject(error)
    }
}
